import type { LocalesDataInterface } from './interfaces'
import type { LocaleInfoInterface } from '@/models'
import type { I18n } from 'vue-i18n'
import { config } from '@/config'
import { createI18n } from 'vue-i18n'

// import the locales from static files
import enUS from './locales/en.json'
// import itIT from './locales/it.json'
// import esES from './locales/es.json'

const dataMap: { key: string; data: LocalesDataInterface }[] = [
  { key: 'en', data: <any>enUS },
  { key: 'en-us', data: <any>enUS },
  //{ key: 'it', data: <any>itIT },
  //{ key: 'es', data: <any>esES },
]

let _i18n: I18n

/**
 * @name: getLocalesData
 * @description: Helper to load the locale json files with each locale data
 */
const getLocalesData = (): LocalesDataInterface => {
  // create the instance that will hold the loaded data
  const localeData: LocalesDataInterface = {
    datetimeFormats: {},
    numberFormats: {},
    messages: {},
  }

  // we use require.context to get all the .json files under the locales sub-directory
  // const files = (require as any).context(
  //   './locales',
  //   true,
  //   /[A-Za-z0-9-_,\s]+\.json$/i
  // )
  // loop through all the files
  //const keys: string[] = files.keys()
  // const keys: string[] = []
  // keys.forEach((key: string) => {
  //   // extract name without extension
  //   const matched = key.match(/([A-Za-z0-9-_]+)\./i)
  //   if (matched && matched.length > 1) {
  //     const localeId = matched[1]
  //     // from each file, set the related messages property
  //     localeData.datetimeFormats[localeId] = files(key).datetimeFormats
  //     localeData.numberFormats[localeId] = files(key).numberFormats
  //     localeData.messages[localeId] = files(key).messages
  //   }
  // })

  dataMap.forEach((dataMapEntry) => {
    const localeId = dataMapEntry.key
    const data = dataMapEntry.data
    // from each file, set the related messages property
    localeData.datetimeFormats[localeId] = data.datetimeFormats
    localeData.numberFormats[localeId] = data.numberFormats
    localeData.messages[localeId] = data.messages
  })

  return localeData
}

const _translate = (key: string, n?: number | string): string => {
  let result = (key || '').trim()
  if (result.length < 1) {
    return ''
  }
  if (_i18n) {
    result = (<any>_i18n.global).t(key) || ''
  }
  if (result.indexOf('[[productName]]') > -1) {
    result = result.replace('[[productName]]', config.brand.productName)
  }
  if (result.indexOf('[[n]]') > -1 && typeof n !== 'undefined') {
    result = result.replace('[[n]]', `${n}`)
  }
  return result
}

const _setLocale = async (lcid: string) => {
  // if (window && window.localStorage) {
  //   window.localStorage.setItem('lcid', lcid)
  // }
  if (_i18n) {
    ;(<any>_i18n.global).locale.value = lcid
    return true
  }
  return false
}

// const _getCurrentLocale = (): string => {
//   // const preferredLcid = window.localStorage.getItem('lcid') || ''
//   // if (preferredLcid.length > 0) {
//   //   ;(<any>_i18n.global).locale.value = preferredLcid
//   // }

//   return ((<any>_i18n.global).locale.value || config.locales.default).toLowerCase()
// }

// const _currentLocaleId = computed((): string => {
//   return ((<any>_i18n.global).locale.value || config.locales.default).toLowerCase()
// })

// const _locales = computed((): LocaleInfoInterface[] => {
//   //return this.$store.state.locales.list as LocaleInfoInterface[]

//   const currentLcid = _currentLocaleId.value
//   const enabledLcids = config.locales.enabled
//   const filtered = config.locales.available.filter((c) => enabledLcids.indexOf(c.id) > -1)
//   // ensure current is selected
//   filtered.forEach((x) => (x.selected = x.id === currentLcid))
//   return filtered
// })

// const _selectedLocale = computed((): LocaleInfoInterface => {
//   return _locales.value.find((x) => x.selected) as LocaleInfoInterface
// })

// const _restoreLocale = async () => {
//   let preferredLcid: string = config.locales.default

//   if (window && window.localStorage) {
//     preferredLcid = localStorage.getItem('lcid') || preferredLcid
//   }

//   // console.log('_restoreLocale', preferredLcid)
//   await _setLocale(preferredLcid)
// }

// export const computedLocalePath = computed((): string => {
//   const lcid = (_currentLocaleId.value || '').trim().toLowerCase()
//   if (lcid === (config.locales.default || '').toLowerCase()) {
//     return ''
//   }
//   return `/${lcid}`
// })

const _initInstance = (data: { messages: any; numberFormats: any }) => {
  // create our data dynamically by loading the JSON files through our getLocalesData helper
  _i18n = createI18n({
    legacy: false,
    locale: config.locales.default,
    fallbackLocale: config.locales.default,
    messages: data.messages,
    //datetimeFormats: data.datetimeFormats,
    numberFormats: data.numberFormats,
  })

  const temp = createI18n({
    legacy: false,
    locale: config.locales.default,
    fallbackLocale: config.locales.default,
    messages: data.messages,
    //datetimeFormats: data.datetimeFormats,
    numberFormats: data.numberFormats,
  })

  temp.global.locale.value = ''
}

const initLocalization = (data: LocalesDataInterface) => {
  if (!_i18n) {
    _initInstance(data)
  }
}

const _getLocalizedPathPrefix = (lcid: string): string => {
  if (lcid === config.locales.default) {
    return ''
  } else {
    return `/${lcid}`
  }
}

interface IUseLocalization {
  defaultLcid: typeof config.locales.default
  locales: LocaleInfoInterface[]
  getLocalizedPathPrefix: typeof _getLocalizedPathPrefix
  // selectedLocale: typeof _selectedLocale
  setLocale: typeof _setLocale
  //restoreLocale: typeof _restoreLocale
  translate: typeof _translate
}

export const useLocalization = (): IUseLocalization => {
  if (!_i18n) {
    const data = getLocalesData()
    initLocalization(data)
  }
  return {
    defaultLcid: config.locales.default,
    locales: config.locales.available.filter((c) => config.locales.enabled.indexOf(c.id) > -1),
    getLocalizedPathPrefix: _getLocalizedPathPrefix,
    // locales: _locales,
    // selectedLocale: _selectedLocale,
    //currentLocaleId: _currentLocaleId,
    setLocale: _setLocale,
    //getCurrentLocale: _getCurrentLocale,
    //restoreLocale: _restoreLocale,
    translate: _translate,
  }
}
